//
//
//
//
//
//
//
//
//
//
//

import ArticleList from './_components/ArticleList';
import MainArticle from './_components/MainArticle';

export default {
  name: 'Article',
  components: {
    ArticleList,
    MainArticle,
  },
  head() {
    return {
      title: 'STEP1NE 文章 - 專業人才獵聘與職業發展資訊',
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: 'STEP1NE 文章 - 深入人力資源與職業發展的專業見解',
        },
        {
          hid: 'description',
          name: 'description',
          content:
            '探索STEP1NE的專業文章，涵蓋人才獵聘、職業發展，及多元人資服務，包括中高階獵才、人資外包與教育訓練，為企業和職場人士提供全方位解決方案。',
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content:
            '探索STEP1NE的專業文章，涵蓋人才獵聘、職業發展，及多元人資服務，包括中高階獵才、人資外包與教育訓練，為企業和職場人士提供全方位解決方案。',
        },
      ],
    };
  },
};
